export const convertCrosspolAdjustmentFormValueToNumber = (
  formValue: string | undefined
): number => {
  if (!formValue) return 0;
  if (isNaN(Number(formValue))) return 0;
  return Math.round(Number(formValue) * 1000) / 1000;
};

export const convertCrosspolAdjustmentFormValueForSaving = (
  formValue: string
): number => {
  return Math.round(
    convertCrosspolAdjustmentFormValueToNumber(formValue) * 1000
  );
};

export const convertCrosspolAdjustmentFromDBForForm = (
  dbValue: number | undefined
): string => {
  if (!dbValue) return '0';
  return (dbValue / 1000).toFixed(2);
};

export const checkValidityOfAdjustmentValue = (
  formValue: string | undefined
): boolean => {
  if (formValue === '') return false;
  if (isNaN(Number(formValue))) return false;
  return true;
};

export const getAdjustedCrossPolData = (
  data: number[],
  adjustmentFormValue: string | undefined
): number[] => {
  if (!checkValidityOfAdjustmentValue(adjustmentFormValue)) return [...data];
  return data.map(
    (value) =>
      value + convertCrosspolAdjustmentFormValueToNumber(adjustmentFormValue)
  );
};
